var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsulin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.24414,
    y: 3,
    width: 54,
    height: 55,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2441 5H44.2441C50.3193 5 55.2441 9.92487 55.2441 16V44C55.2441 50.0751 50.3193 55 44.2441 55H16.2441C10.169 55 5.24414 50.0751 5.24414 44V16C5.24414 9.92487 10.169 5 16.2441 5ZM0.244141 16C0.244141 7.16344 7.40759 0 16.2441 0H44.2441C53.0807 0 60.2441 7.16344 60.2441 16V44C60.2441 52.8366 53.0807 60 44.2441 60H16.2441C7.40758 60 0.244141 52.8366 0.244141 44V16ZM29.7441 45C35.5431 45 40.2441 40.243 40.2441 34.375C40.2441 27.8125 30.6706 15 29.7441 15C28.8177 15 19.2441 27.5 19.2441 34.375C19.2441 40.243 23.9452 45 29.7441 45Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsulin);
export default __webpack_public_path__ + "static/media/insulin.47d69106496576a8967fc8f889f72c8a.svg";
export { ForwardRef as ReactComponent };